/**
 * AdminOrcaRunnerRpcClient - AtomRpc integration for admin orca runner endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaRunnerRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaRunnerRpcClient extends AtomRpc.Tag<AdminOrcaRunnerRpcClient>()(
  "AdminOrcaRunnerRpcClient",
  {
    group: AdminOrcaRunnerRpcs,
    protocol: makeRpcClientLayer(AdminOrcaRunnerRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
